module.exports = __webpack_public_path__ + "img/capability-app-tablet-mini.ab7c7afe.png";